@if (project$ | async; as project) { @if (facilityId$ | async; as facilityId) {
<a class="facility-link" [routerLink]="['/project', project.id, 'facility', facilityId]">
  <button class="iconf-btn-blank minw50">
    <mat-icon class="arrow lightblue">chevron_left</mat-icon>
  </button>
</a>
}
<div>
  <span class="project lightblue">{{ project.businessUnit + ' Project: ' + project.name }}</span>
  <span class="project grey"> > System selection</span>
  <span class="project grey"> > System configure</span>
  @if (system$ | async; as system) {
  <div class="title">{{ system.name }}</div>
  <div class="system-info">
    <div class="status"><app-status-badge [status]="system.status"></app-status-badge></div>
    <app-separator></app-separator>
    <div class="progress grey">
      @if ((system.numQuestionsAnswered / system.numQuestionsTotal) * 100; as progress) {
      {{ progress | number : '1.0-0' }} %
      <app-progress-bar [progress]="progress"></app-progress-bar>
      } @else { @if (system.numQuestionsTotal) {
      <span class="progress-number"> 0 % </span>
      <app-progress-bar [progress]="0"></app-progress-bar>
      } @else {
      <span class="progress-number"> 100 % </span>
      <app-progress-bar [progress]="100"></app-progress-bar>
      } }
      {{ system.numQuestionsAnswered }}/{{ system.numQuestionsTotal }} parameters
    </div>
    <!-- TODO: Display system creator -->
  </div>
  }
</div>
}

<app-user-button class="usr-btn"></app-user-button>
